<app-user-dashboard [userMenuActiveItemIndex]="0" [activeItem]="'corporative'">
  <app-user-panel-detail/>
</app-user-dashboard>
